export const CONNECT = 'connect'
export const DISCONNECT = 'disconnect'
export const CONNECT_ERROR = 'connectError'
export const UNAUTHORIZED = 'unauthorized'
export const RECONNECT_FAILED = 'reconnectFailed'
